<template>
  <LoadingSpinner v-if="!parametros" />
  <div class="py-4 container" v-else>
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <h6 class="pt-5 pb-2">{{ parametros.arrendamiento }}</h6>
          <form class="card p-4" @submit.prevent="update">
            <div class="table-responsive">
              <table class="table table-bordered table-sm text-center">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Fondeo</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.fondeo"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>TIIE</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.tiie"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th colspan="2">Comisiones</th>
                  </tr>
                  <tr>
                    <th>Ejecutivo</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.comision_ejecutivo"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Lider</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.comision_lider"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Agencia</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.comision_agencia"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Externo</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.comision_externo"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Marketing</th>
                    <td>
                      <input
                        type="tel"
                        class="form-control form-control-sm"
                        autocomplete="off"
                        v-model="parametros.comision_marketing"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-center mt-4">
              <button
                class="btn btn-primary btn-sm me-2"
                type="submit"
                :disabled="modificando"
              >
                Guardar
              </button>
              <router-link
                :to="{
                  name: 'cotizacion-unidades-parametros',
                }"
              >
                <button class="btn btn-sm" type="button">Cancelar</button>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useCotizacionParametros } from "@/composables/useCotizacionParametros";
import LoadingSpinner from "@/components/LoadingComponent.vue";

const {
  camposDeshabilitados,
  edit,
  modificando,
  parametros,
  update,
} = useCotizacionParametros();

onMounted(() => {
  edit();
});
</script>
